const heritageBase = "/images/vst-filmstrips/heritage";
const knobAssetBase = "/images/vst-knobs";

export const VST_KNOB_ASSETS = {
  modernSpectrum: { url: `${knobAssetBase}/modern-spectrum-knob-v2.png`, frames: 1, frameWidth: 1254, frameHeight: 1254, staticFace: true },
  studioScallop: { url: `${heritageBase}/studio-scallop-knob-64x128-v2.png`, frames: 64, frameWidth: 128, frameHeight: 128 },
  blackPrecision: { url: `${heritageBase}/black-precision-knob-64x128-v1.png`, frames: 64, frameWidth: 128, frameHeight: 128 },
  crimsonWing: { url: `${heritageBase}/crimson-wing-knob-64x128-v4.png`, frames: 64, frameWidth: 128, frameHeight: 128 },
  blackCrimsonWing: { url: `${heritageBase}/black-crimson-wing-knob-64x128-v1.png`, frames: 64, frameWidth: 128, frameHeight: 128 },
  regentWhiteWing: { url: `${heritageBase}/regent-white-wing-knob-64x128-v1.png`, frames: 64, frameWidth: 128, frameHeight: 128 },
  graphiteRidge: { url: `${heritageBase}/graphite-ridge-knob-64x128-v1.png`, frames: 64, frameWidth: 128, frameHeight: 128 },
};

export const VST_FILMSTRIP_SKINS = {
  heritage: {
    id: "heritage",
    name: "Heritage Hardware",
    format: "hise-vertical-filmstrip",
    knob: { url: `${heritageBase}/heritage-knob-64x128-v2.png`, frames: 64, frameWidth: 128, frameHeight: 128 },
    pultecKnob: { url: `${heritageBase}/pultec-knob-64x128-v1.png`, frames: 64, frameWidth: 128, frameHeight: 128 },
    button: { url: `${heritageBase}/heritage-button-6x96.png`, frames: 6, frameWidth: 96, frameHeight: 96 },
    fader: { url: `${heritageBase}/heritage-fader-64x96x256.png`, frames: 64, frameWidth: 96, frameHeight: 256 },
    meter: { url: `${heritageBase}/heritage-meter-64x256x128.png`, frames: 64, frameWidth: 256, frameHeight: 128 },
  },
};

export const DEFAULT_VST_FILMSTRIP_SKIN = VST_FILMSTRIP_SKINS.heritage;

export const filmstripFrameStyle = (asset, frame) => {
  const safeFrame = Math.max(0, Math.min(asset.frames - 1, Math.round(Number(frame) || 0)));
  return {
    backgroundImage: `url(${asset.url})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: `100% ${asset.frames * 100}%`,
    backgroundPosition: `center ${asset.frames > 1 ? (safeFrame / (asset.frames - 1)) * 100 : 0}%`,
    aspectRatio: `${asset.frameWidth} / ${asset.frameHeight}`,
  };
};
